import ClickstreamService, {
    ClickstreamEventType,
} from 'clickstream/ClickstreamService';
import { WidgetType } from 'widgets/WidgetType';

interface UsageByTimeEvent {
    widgetUsage: Set<WidgetType>;
    widgetFeatureUsage: Partial<Record<WidgetType, Set<string>>>;
}

export class ClickstreamUsageByTime {
    private from = Date.now();
    private interval: NodeJS.Timeout | undefined;

    private event: UsageByTimeEvent = {
        widgetUsage: new Set(),
        widgetFeatureUsage: {},
    };

    public constructor(private clickstreamService: ClickstreamService) {
        this.startInterval();
    }

    /*
     * Records usage of a widget i.e. on Mouseover
     */
    public recordWidgetUsage(widgetType: WidgetType) {
        this.event.widgetUsage.add(widgetType);
    }

    public recordWidgetUsages(widgetTypes: WidgetType[]) {
        for (const wt of widgetTypes) {
            this.recordWidgetUsage(wt);
        }
    }

    /*
     * Records usage of a feature of a widget i.e. hovering over the last bucket in Intraday profiles
     */
    public recordWidgetFeatureUsage(widgetType: WidgetType, feature: string) {
        const widgetFeatures =
            this.event.widgetFeatureUsage[widgetType] ?? new Set();
        widgetFeatures.add(feature);
        this.event.widgetFeatureUsage[widgetType] = widgetFeatures;
    }

    public flush() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.send();
        this.startInterval();
    }

    private startInterval() {
        this.interval = setInterval(this.send.bind(this), 300000);
    }

    private send() {
        const widgetUsage = Array.from(this.event.widgetUsage);
        const widgetFeatureUsageKeys = Object.keys(
            this.event.widgetFeatureUsage
        ) as WidgetType[];
        const widgetFeatureUsage = this.event.widgetFeatureUsage;

        this.event.widgetUsage.clear();
        this.event.widgetFeatureUsage = {};

        if (widgetUsage.length > 0 || widgetFeatureUsageKeys.length > 0) {
            const from = this.from;
            const to = Date.now();

            this.clickstreamService.postEvent(
                ClickstreamEventType.USAGE_BY_TIME,
                {
                    from,
                    to,
                    widgets: widgetUsage,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'widget-usage': toWidgetUsagePayload(
                        widgetFeatureUsageKeys,
                        widgetFeatureUsage
                    ),
                }
            );
        }
        this.from = Date.now();
    }
}
function toWidgetUsagePayload(
    keys: WidgetType[],
    widgetFeatureUsage: Partial<Record<WidgetType, Set<string>>>
) {
    return keys.reduce((r: Partial<Record<string, Array<string>>>, key) => {
        r[key] = Array.from(widgetFeatureUsage[key]!);
        return r;
    }, {});
}
